// FormikSubmitButton.tsx
import { Button } from './Button/Button';
import { useFormikContext } from 'formik';
import type { ButtonProps } from '@gokrew/models/button';

interface Props extends ButtonProps {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  requireDirty?: boolean;
}

export function FormikSubmitButton({
  children,
  className,
  disabled,
  requireDirty = true,
  ...props
}: Props) {
  const { isValid, dirty, isSubmitting } = useFormikContext();

  return (
    <Button
      {...props}
      type="submit"
      disabled={(requireDirty && !dirty) || !isValid || isSubmitting || disabled}
      className={className}
    >
      {children}
    </Button>
  );
}
